import { defineComponent as _defineComponent } from 'vue'
import TheHomeLeftTop from './TheHomeLeftTop.vue';
import TheHomeLeftBottom from './TheHomeLeftBottom.vue';

import TheHomeRight from './TheHomeRight.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TheHome',
  setup(__props) {


return { __sfc: true,TheHomeLeftTop, TheHomeLeftBottom, TheHomeRight }
}

})